import { Box, type FormControlSizes, HStack, IconButton, IconName, Tooltip } from '@talos/kyoko';
import type { MouseEvent, ReactNode } from 'react';
import { MARKET_CARD_CONTROL_TOOLTIP_PROPS } from '../marketCardControlTooltipProps';

export function NavigableControlRow({
  left,
  right,
  children,
}: {
  left?: ReactNode;
  right?: ReactNode;
  children: ReactNode;
}) {
  return (
    <HStack w="100%">
      {left}
      <Box flex="1" minWidth={0}>
        {children}
      </Box>
      {right}
    </HStack>
  );
}

export function NavigableControlArrow({
  direction,
  size,
  onClick,
  className,
  dataTestID,
  tooltip,
}: {
  direction: 'previous' | 'next';
  size?: FormControlSizes;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  dataTestID?: string;
  tooltip?: ReactNode;
}) {
  const ariaLabel = typeof tooltip === 'string' || typeof tooltip === 'number' ? String(tooltip) : undefined;
  const button = (
    <IconButton
      icon={direction === 'previous' ? IconName.ChevronLeft : IconName.ChevronRight}
      size={size}
      onClick={onClick}
      className={className}
      data-testid={dataTestID}
      aria-label={ariaLabel}
    />
  );

  if (tooltip == null || tooltip === false) {
    return button;
  }

  return (
    <Tooltip tooltip={tooltip} {...MARKET_CARD_CONTROL_TOOLTIP_PROPS}>
      {button}
    </Tooltip>
  );
}
